<div class="container">
  <div class="header">
    <h3>{{ currentCategoryLabel() }}</h3>
    <button (click)="close()">
      <ui-icon faName="xmark" faStyle="light"></ui-icon>
      Schließen
    </button>
  </div>
  @if (navigationRoot(); as navigationRoot) {
    <ui-toggle-navigation
      [navigationRoot]="navigationRoot"
      [selectedItem]="currentCategory()"
      (selectionChange)="categoryChanged.emit($event)"
      [topLevelTiles]="showTiles()"
      [enableNavigationTracking]="false"
    ></ui-toggle-navigation>
  } @else {
    <ui-mobile-navigation-skeleton></ui-mobile-navigation-skeleton>
  }
</div>
